<template>
  <div ref="input" class="input" :class="{full: input.full_width}">
    <label class="optionalPosition">{{input.label}} <p class="optional" v-if="input.optional">(optional)</p> </label> 
   
    <input v-model="answer" :type="input.type" @keyup="saveAnswer" />
  </div>
</template>

<script>
export default {
  name: "NormalInput",
  props: ["input", "questionIndex", "answerKey"],
  data() {
    return {
      answer: null
    };
  },
  mounted() {},
  created() {
        this.answer = this.input.value;
  },
  firestore() {
    return {};
  },
  methods: {
    saveAnswer(e) {
      if(this.input.label == "Credit Score"){
        if(this.answer.length > 3){
          this.answer = this.answer.slice(0,3);
        }
      }
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.answer
      );
    }
  },
  watch: {}
};
</script>

<style scoped lang='scss'>

</style>
